import N8nToggle from './Toggle.vue';

export default N8nToggle;
